import { doc, runTransaction } from 'firebase/firestore';
import { db } from './firebase/config';

/**
 * Atomically allocates the next sequential number for a counter document.
 * Uses a Firestore transaction to prevent race conditions when multiple tabs
 * or users create documents concurrently.
 *
 * Counter doc stores { count: N } where N is the last-used number.
 * Returns a formatted string like "ה26/001".
 */
export async function allocateSequentialNumber(
  counterPath: string[],
  prefix: string
): Promise<string> {
  const year = new Date().getFullYear().toString().slice(-2);
  // Non-empty tuple assertion: callers always pass at least one path segment
  const counterRef = doc(db, ...(counterPath as [string, ...string[]]));

  const count = await runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);
    if (!snap.exists()) {
      tx.set(counterRef, { count: 1 });
      return 1;
    }
    const next = (snap.data().count as number) + 1;
    tx.update(counterRef, { count: next });
    return next;
  });

  return `${prefix}${year}/${count.toString().padStart(3, '0')}`;
}
